import { ALL_LAYOUT_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import Super from '../base.gjs';
import VariableLayout from '../../layout/variable.gjs';
import styles from './header.module.scss';

const METADATA = Metadata.define({
  description: 'Header for menus',
  extends: [ALL_LAYOUT_ARGS, pick(ALL_LAYOUT_ARGS, [{ name: 'gap', defaultValue: '8px' }])],
  name: 'Menu Header',
});

export default class SpdsCoreMenuHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-menu-header';
  styles = styles;

  get column() {
    return this.argOrDefault('column');
  }

  get gap() {
    return this.argOrDefault('gap');
  }

  <template>
    <VariableLayout
      @column={{this.column}}
      @gap={{this.gap}}
      class={{this.classes}}
      data-test-spds-menu-header
      ...attributes
      {{this.validateArguments}}
    >
      {{yield}}
    </VariableLayout>
  </template>
}

export const SPDS_CORE_MENU_HEADER_METADATA = SpdsCoreMenuHeader.metadata;
